import { render, staticRenderFns } from "./ArtworkFinished.vue?vue&type=template&id=a133c5fa"
import script from "./ArtworkFinished.vue?vue&type=script&lang=js"
export * from "./ArtworkFinished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports